import { getCookieByName, removeCookie } from "./cookie";
import {
  IMPERSONATION_COOKIE,
  STADIUM_IMPERSONATION_COOKIE_DOMAIN,
} from "@stadium/constants/impersonation";

export const getImpersonationParams = () => {
  const impersonateCookie: string = getCookieByName(IMPERSONATION_COOKIE);
  return { ...(impersonateCookie && { "Impersonate-As": decodeURIComponent(impersonateCookie) }) };
};

export const getImpersonatedUser = () =>
  decodeURIComponent(getCookieByName(IMPERSONATION_COOKIE) || "");

export const endImpersonationSession = ({ domain = STADIUM_IMPERSONATION_COOKIE_DOMAIN } = {}) =>
  removeCookie(IMPERSONATION_COOKIE, "/", domain) as void;
